import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useHomeRevenueV2({
  branchIds,
  start,
  end,
  tipo,
  groupBy = "none",
  compare,
  sellers = [],
  enabled = true,
}) {
  const { getRevenueMetrics } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: [
      "homeRevenueV2",
      user?.user_id ?? null,
      branchIds,
      start,
      end,
      tipo,
      groupBy,
      sellers,
      compare ?? null,
    ],
    queryFn: () =>
      getRevenueMetrics({
        branch_id: branchIds,
        start,
        end,
        tipo,
        group_by: groupBy,
        ...(compare ? { compare } : {}),
        ...(sellers.length ? { seller: sellers } : {}),
      }),
    enabled: Boolean(enabled && branchIds?.length && start && end),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
